// Meta Pixel (browser). Loaded only for visitors outside regions that require
// advertising consent (no consent banner route). Visitors in those regions, or
// whose region can't be resolved, are never tracked.
export const META_PIXEL_ID = "1061885232907262";

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  push?: unknown;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

// EU/EEA, UK, Switzerland
const CONSENT_REGIONS = new Set([
  "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE","IS","LI","NO","GB","CH",
]);

let allowed = false;
let initPromise: Promise<boolean> | null = null;

async function resolveAllowed(): Promise<boolean> {
  try {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), 2000);
    const res = await fetch("/cdn-cgi/trace", { signal: ctrl.signal });
    clearTimeout(t);
    if (!res.ok) return false;
    const loc = /loc=([A-Z0-9]{2})/.exec(await res.text())?.[1];
    if (!loc || loc === "XX" || loc === "T1") return false;
    return !CONSENT_REGIONS.has(loc);
  } catch {
    return false;
  }
}

function call(...args: unknown[]) {
  const f = window.fbq;
  if (!f) return;
  if (f.callMethod) f.callMethod.apply(f, args);
  else (f.queue as unknown[]).push(args);
}

function loadBase() {
  if (window.fbq) return;
  const n = function (...args: unknown[]) {
    if (n.callMethod) n.callMethod.apply(n, args);
    else (n.queue as unknown[]).push(args);
  } as Fbq;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);
  call("init", META_PIXEL_ID, {}, { agent: "lovable" });
}

export function initMetaPixel(): Promise<boolean> {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (!initPromise) {
    initPromise = resolveAllowed().then((ok) => {
      allowed = ok;
      if (ok) loadBase();
      return ok;
    });
  }
  return initPromise;
}

function eventId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export async function trackMeta(event: string, params?: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  await initMetaPixel();
  if (!allowed) return;
  call("track", event, params ?? {}, { eventID: eventId() });
}
